import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';
import { CancelButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';
import { ConfirmButton } from 'components/ui/Button';

const SubsetOfPassengersInPalsBookingWarning = ({ isOpen, closeModal, handleClick, loading = false, isDisabled = false }) => (
  <Modal
    isOpen={isOpen}
    title={<FormattedMessage id="aftersalesWarning.subsetPalsTitle" />}
    subtitle={<FormattedMessage id="aftersalesWarning.subsetPalsText" />}
    onClose={closeModal}
  >
    <Row>
      <StyledColumn span={4}>
        <CancelButton data-cy="cancel" onClick={closeModal}>
          <FormattedMessage id="exchanges.adandon" />
        </CancelButton>
      </StyledColumn>
      <StyledColumn span={4}>
        <ConfirmButton data-cy="confirm" onClick={handleClick} loading={loading} disabled={isDisabled}>
          <FormattedMessage id="exchanges.confirm" />
        </ConfirmButton>
      </StyledColumn>
    </Row>
  </Modal>
);

SubsetOfPassengersInPalsBookingWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  handleClick: PropTypes.func,
  loading: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default SubsetOfPassengersInPalsBookingWarning;
